import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column",
  "data-kt-landing": "true"
}
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = { class: "fw-normal landingTitle flex-fill" }
const _hoisted_4 = { class: "landingSubtitle pb-5" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "form-floating my-5" }
const _hoisted_8 = {
  selected: "true",
  value: undefined
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-label mb-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "mt-10 mb-3 fs-3"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "row g-0 align-items-center" }
const _hoisted_15 = { class: "col-2 px-1" }
const _hoisted_16 = { class: "col-9" }
const _hoisted_17 = { class: "card-body ps-0" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "card-text text-muted" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar" }, null, -1)
const _hoisted_21 = {
  class: "card-text truncate",
  style: {"white-space":"pre-line"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right fs-2x" })
], -1)
const _hoisted_23 = {
  key: 1,
  class: "textoCentrado mt-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FamiliaInfo = _resolveComponent("FamiliaInfo")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.i18n("planCorresponsables")), 1),
        _createVNode(_component_FamiliaInfo)
      ]),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.i18n("serviciosInscripcionesAbiertasTitulo")), 1),
      _createElementVNode("div", {
        class: "textoJustificado",
        style: {"white-space":"pre-line"},
        innerHTML: _ctx.$t('descripcionServiciosInscripcionesAbiertas')
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("select", {
          name: "comarca",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comarca) = $event)),
          class: "form-select form-select-solid",
          style: {"max-width":"300px"}
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.i18n("OpcionVerTodasLasComarcas")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (comarca, i) => {
            return (_openBlock(), _createElementBlock("option", {
              value: comarca.id,
              key: i
            }, _toDisplayString(comarca.text), 9, _hoisted_9))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.comarca]
        ]),
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.i18n("DireccionComarcaLabel")), 1)
      ]),
      (_ctx.datosServicios.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosServicios, (item, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                (
            _ctx.datosServicios[i].comarca.nombre !==
              _ctx.datosServicios[i - 1]?.comarca?.nombre && !_ctx.comarca
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.comarca.nombre), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "card mb-3",
                  style: {"cursor":"pointer"},
                  onClick: ($event: any) => (_ctx.onItemTap(item))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-3x img-fluid rounded-circle d-block mx-auto textoCentrado", item.iconoCls])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("h3", _hoisted_18, _toDisplayString(item.nombre), 1),
                        _createElementVNode("p", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.moment(item.servicio.inicioPrevisto).format("LL")) + " a " + _toDisplayString(_ctx.moment(item.servicio.finPrevisto).format("LL")), 1)
                        ]),
                        _createElementVNode("p", _hoisted_21, _toDisplayString(item.descripcion), 1)
                      ])
                    ]),
                    _hoisted_22
                  ])
                ], 8, _hoisted_13)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createTextVNode(_toDisplayString(_ctx.loading
          ? _ctx.i18n("cargandoServiciosColectivosEnComarca")
          : _ctx.i18n("sinServiciosColectivosEnComarca")) + " ", 1),
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                  key: 0,
                  animationLink: "https://assets3.lottiefiles.com/packages/lf20_rc6CDU.json",
                  height: 200,
                  width: 200
                }))
              : _createCommentVNode("", true)
          ]))
    ])
  ], 64))
}